module.exports = __webpack_public_path__ + "static/media/overlay1.5b3bfcc6.png";